<template>
  <DMModal @modal-close="reset" name="subscribe">
    <div class="flex flex-col">
      <p class="text-center mb-3">Join Our Mailing List</p>
      <label>
        <input
          class="text-input placeholder-gray-500 placeholder-opacity-50 mb-3"
          type="text"
          v-model="subscribe.email"
          placeholder="Email"
        />

        <p v-if="request.error === true && request.data.errors.email" class="text-red-500 text-center mb-3">
          {{ request.data.errors.email[0] }}
        </p>
      </label>
      <label>
        <input
          v-model="subscribe.first_name"
          class="text-input placeholder-gray-500 placeholder-opacity-50 mb-3"
          type="text"
          placeholder="First name"
        />
        <p v-if="request.error === true && request.data.errors.first_name" class="text-red-500 text-center mb-3">
          {{ request.data.errors.first_name[0] }}
        </p>
      </label>

      <label>
        <input
          class="text-input placeholder-gray-500 placeholder-opacity-50 mb-3"
          type="text"
          v-model="subscribe.last_name"
          placeholder="Last name"
        />
        <p v-if="request.error === true && request.data.errors.last_name" class="text-red-500 text-center mb-3">
          {{ request.data.errors.last_name[0] }}
        </p>
      </label>
      <p v-if="request.subscribed === true" class="text-green-500 text-center font-medium mb-3">
        {{ request.data.message }}
      </p>
      <p v-if="request.error === true && request.data.unknown" class="text-red-500 text-center font-medium mb-3">
        {{ request.data.message }}
      </p>
      <button
        v-if="!sending"
        :disabled="!canSend"
        @click="handle"
        :class="{
          'mx-auto bg-white-50 w-1/2 py-2 px-3 rounded-full mb-3 text-center': true,
          'opacity-50': !canSend,
          'hover:bg-dm': canSend,
        }"
      >
        Join
      </button>
      <loader class="mx-auto" v-else />
    </div>
  </DMModal>
</template>

<script>
import DMModal from '@components/DMModal';
import Loader from '@components/Loader';
export default {
  name: 'SubscribeModal',
  components: { Loader, DMModal },
  data() {
    return {
      subscribe: {
        email: null,
        first_name: null,
        last_name: null,
      },
      request: {
        error: false,
        sent: false,
        data: {},
      },
      sending: false,
    };
  },
  computed: {
    canSend() {
      return (
        !this.sending &&
        this.subscribe.email !== null &&
        this.subscribe.first_name !== null &&
        this.subscribe.last_name !== null
      );
    },
  },
  methods: {
    handle() {
      this.sending = true;
      this.request.error = false;
      this.request.subscribed = false;
      this.request.data = {};
      axios
        .post('/api/subscribe', this.subscribe)
        .then(({ status, data }) => {
          if (status === 200) {
            if (data.subscribed) {
              this.request.subscribed = true;
              this.subscribe = {
                email: null,
                first_name: null,
                last_name: null,
              };
              this.request.data.message = 'Succesfully subscribed to our mailing list!';
            } else {
              this.request.error = true;
              this.request.data.unknown = true;
              this.request.data.errors = {};
              this.request.data.message =
                'There was an issue subscribing you to our mailing list, you may already be subscribed.';
            }
          }
        })
        .catch(({ response }) => {
          if (response.status === 422) {
            // Validation
            this.request.error = true;
            this.request.data = response.data;
          }
        })
        .finally(() => {
          this.sending = false;
          this.$set(this.$data, 'request', this.request);
        });
    },
    reset() {
      this.subscribe = {
        email: null,
        first_name: null,
        last_name: null,
      };
      this.request = {
        error: false,
        sent: false,
        data: {},
      };
    },
  },
};
</script>

<style scoped></style>
